import React from 'react';
import SEO from "./seo";

export default function RittalCatalogBanner(props) {
  const {isInShop = false} = props;
  const seo = {
    pageTitle: 'Rittal в наличии в России',
    description: 'Купить шкафы RITTAL (TS, VX, AE/AX корпуса) со склада в Росиии от AMG, стойки IT, монтажные панели, замки Rittal, двери, вентиляторы/фильтры, шины, кондиционеры щитовые, светильники в щит SZ, блоки розеток, цоколи, линейные шкафы, клеммные коробки, обогреватели/нагреватели в щит, профиль, термостаты, адаптеры, датчики'
  };
  return (
    <div id="rittalCatalogBanner">
      {isInShop && <SEO title={seo.pageTitle} description={seo.description} />}
      <div className="inner">
        {/* <ContactForm /> */}
        {/*<section>*/}
          <div className="row" style={{margin: 0}}>
            <div className="col-sm-12">
              {isInShop ? <>
                <h1>Rittal в наличии в России</h1>
              </> : <>
                <h2>Широкий ассортимент оборудования Риттал на складе в России</h2>
              </>}
              {isInShop ? <>
                <div>Купить шкафы RITTAL серий TS, FB, VX, корпуса AE/AX, монтажные панели, стойки IT, линейные шкафы, замки Риттал, двери, вентиляторы/фильтры, шины, кондиционеры щитовые, блоки розеток, цоколи Ритал, клеммные коробки, обогреватели/нагреватели, светильники, термостаты, датчики.
                  Каталог оборудования в наличии на складе.</div>
              </> : <>
                <div>Шкафы RITTAL серий TS, FB, VX, корпуса AE/AX, монтажные панели, стойки IT, линейные шкафы, замки Риттал, двери, вентиляторы/фильтры, шины, кондиционеры щитовые и многое другое...</div>
              </>}
            </div>
          </div>
          <div className="row download" style={{margin: 0}}>
            <div className="col-sm-12">
              <h3><a href="//distribution.amgcorporation.de/catalog/rittal/AMG_Rittal-parts.xlsx" download="AMG_Rittal-parts" alt="каталог Rittal со склада">Скачать каталог</a></h3>
            </div>
          </div>
        {/*</section>*/}
      </div>
    </div>
  );
}
